import sistemaBNCCService from "./SistemaBNCCService";
import alunosService from "./AlunosService";
import anosService from "./AnosService";
import authService from "./AuthService";
import caixasService from "./CaixasService";
import franquiasService from "./FranquiasService";
import matriculasService from "./MatriculasService";
import formasDePagamentoService from "./FormasDePagamentoService";
import parcelasService from "./ParcelasService";
import turmasService from "./TurmasService";
import turnosService from "./TurnosService";
import seriesService from "./SeriesService";
import cursosService from "./CursosService";
import cepService from "./CepService";
import disciplinasService from "./DisciplinasService";
import professoresService from "./ProfessoresService";
import usuariosService from "./UsuariosService";
import inepService from "./InepService";
import gestoesDeAulasService from "./GestoesDeAulasService";
import gestoesDeAulasAEEService from "./GestoesDeAulasAEEService";
import gestoesDeAulasAuxiliaresService from "./GestoesDeAulasAuxiliaresService";
import aulasService from "./AulasService";
import notasService from "./NotasService";
import relatoriosService from "./RelatoriosService";
import tiposDeEnsinosService from "./TiposDeEnsinosService";
import educacaoInclusivaService from "./EducacaoInclusivaService";
import planosBimestraisService from "./planosBimestraisService";
import planosAnuaisService from "./planosAnuaisService";
import planosBimestraisInfantilService from "./planosBimestraisInfantilService";
import planosAnuaisInfantilService from "./planosAnuaisInfantilService";
import rolesService from "./RolesService";
import responsavelAlunoService from "./ResponsavelAlunoService";
import avisosService from "./AvisosService";
import imageService from "./ImageService";
import objetivosAprendizagem from "./ObjetivosAprendizagem";
import horariosService from "./HorariosService";
import agendasService from "./AgendaService";
import notifiqService from "./NotifiqService";
import presencasService from "./PresencasService";
import appConfigurationService from "./AppConfigurationService";
import webInfo from "./WebInfo";
import informativosService from "./InformativosService";
import historicoService from "./HistoricoService";
import salaDeSituacaoService from "./SalaDeSituacaoService";
import instrutorHorariosService from "./InstrutorHorariosService";
import colaboradorPontosService from "./ColaboradorPontosService";

const $services = {
  alunosService,
  anosService,
  authService,
  caixasService,
  franquiasService,
  matriculasService,
  formasDePagamentoService,
  parcelasService,
  turmasService,
  turnosService,
  seriesService,
  cursosService,
  cepService,
  disciplinasService,
  professoresService,
  usuariosService,
  inepService,
  gestoesDeAulasService,
  gestoesDeAulasAEEService,
  aulasService,
  notasService,
  relatoriosService,
  sistemaBNCCService,
  tiposDeEnsinosService,
  educacaoInclusivaService,
  planosBimestraisService,
  planosAnuaisService,
  rolesService,
  responsavelAlunoService,
  avisosService,
  imageService,
  planosBimestraisInfantilService,
  planosAnuaisInfantilService,
  objetivosAprendizagem,
  horariosService,
  gestoesDeAulasAuxiliaresService,
  agendasService,
  notifiqService,
  presencasService,
  appConfigurationService,
  salaDeSituacaoService,
  webInfo,
  informativosService,
  historicoService,
  instrutorHorariosService,
  colaboradorPontosService,
};

export default $services;
